import './index.scss';

class Loader {
  constructor() {
    // Navigation API (https://developer.mozilla.org/en-US/docs/Web/API/Navigation_API)
    this.hasNavigationApi = globalThis.navigation && 'addEventListener' in globalThis.navigation;

    if (!this.hasNavigationApi) {
      return;
    }

    if (Loader.instance) {
      this.loader = Loader.instance.loader;
    } else {
      this.loader = document.createElement('div');
      this.loader.className = 'f-loader';

      if (document.readyState === 'complete') {
        this.hide();
      }

      globalThis.addEventListener('beforeunload', () => {
        if (['mailto:', 'tel:'].some((item) => document.activeElement?.getAttribute('href')?.includes(item))) {
          return;
        }

        this.show();
      });

      globalThis.addEventListener('pageshow', () => this.hide());

      globalThis.navigation.addEventListener('navigate', (event) => {
        if (event.canIntercept) {
          event.signal.addEventListener('abort', () => this.hide());
        }
      });

      Loader.instance = this;
    }
  }

  show() {
    if (!document.body.contains(this.loader)) {
      document.body.appendChild(this.loader);
    }
  }

  hide() {
    if (document.body.contains(this.loader)) {
      this.loader.remove();
    }
  }
}

export default new Loader();
